import React from "react";
import PropTypes from "prop-types";
import { Card, Grid, InputLabel, MenuItem, Select } from "@mui/material";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftInputNumber from "components/SoftInputNumberUpgrade";
import Firma from "../Firma";

const Infraestructura = ({ infraestructura, finalizada }) => {
  return (
    <Grid container spacing={2} p={2}>
      <Grid item xs={12}>
        <SoftTypography color="black" variant="h4" fontWeight="bold">
          Infraestructura
        </SoftTypography>
      </Grid>
      <Grid item xs={12}>
        <SoftTypography
          variant="body2"
          sx={{
            lineHeight: 0.5,
          }}
          color="black"
        >
          Días Laborales: {infraestructura.diasLaborales || ""}
        </SoftTypography>
      </Grid>
      <Grid item xs={12}>
        <SoftTypography
          variant="body2"
          sx={{
            lineHeight: 0.5,
          }}
          color="black"
        >
          Cantidad de Empleados: {infraestructura.cantidadDeEmpleados || ""}
        </SoftTypography>
      </Grid>
      <Grid item xs={12}>
        <SoftTypography
          variant="body2"
          sx={{
            lineHeight: 0.5,
          }}
          color="black"
        >
          Agua Potable(Consumo humano,lavados,cocina, bebida): {infraestructura.aguaPotable || "0"}{" "}
          M3/Año
        </SoftTypography>
      </Grid>
      <Grid item xs={12}>
        <SoftTypography
          variant="body2"
          sx={{
            lineHeight: 0.5,
          }}
          color="black"
        >
          Agua Utilizada en Proceso Industrial: {infraestructura.aguaProcesoIndustrial || "0"}{" "}
          M3/Año
        </SoftTypography>
      </Grid>
      <Grid item xs={12}>
        <SoftTypography
          variant="body2"
          sx={{
            lineHeight: 0.5,
          }}
          color="black"
        >
          Origen Agua Potable: {infraestructura.potable || ""}
        </SoftTypography>
      </Grid>
      <Grid item xs={12}>
        <SoftTypography
          variant="body2"
          sx={{
            lineHeight: 0.5,
          }}
          color="black"
        >
          Origen Agua Cruda: {infraestructura.cruda || ""}
        </SoftTypography>
      </Grid>
      <Grid item xs={12}>
        <SoftTypography
          variant="body2"
          sx={{
            lineHeight: 0.5,
          }}
          color="black"
        >
          Conexión Cloacal:{" "}
          {infraestructura.conexionCloacal
            ? "SI " + (infraestructura.cantidadConexionCloacal || 0) + " M3/Año"
            : "NO"}
        </SoftTypography>
      </Grid>
      <Grid item xs={12}>
        <SoftTypography
          variant="body2"
          sx={{
            lineHeight: 0.5,
          }}
          color="black"
        >
          Pozo Absorbente:{" "}
          {infraestructura.pozoAbsorvente
            ? "SI " + (infraestructura.cantidadPozoAbsorvente || 0) + " M3/Año"
            : "NO"}
        </SoftTypography>
      </Grid>
      <Grid item xs={12}>
        <SoftTypography
          variant="body2"
          sx={{
            lineHeight: 0.5,
          }}
          color="black"
        >
          Piletas/Lagunas de tratamiento:{" "}
          {infraestructura.piletasLagunasDeTratamiento
            ? "SI " + (infraestructura.cantidadPiletasLagunasDeTratamiento || 0) + " M3/Año"
            : "NO"}
        </SoftTypography>
      </Grid>
      <Grid item xs={12}>
        <SoftTypography
          variant="body2"
          sx={{
            lineHeight: 0.5,
          }}
          color="black"
        >
          Planta de Tratamiento de Efluentes:{" "}
          {infraestructura.plantaTratamiento
            ? "SI " + (infraestructura.cantidadPlantaTratamiento || 0) + " M3/Año"
            : "NO"}
        </SoftTypography>
      </Grid>
      <Grid item xs={12}>
        <SoftTypography
          variant="body2"
          sx={{
            lineHeight: 0.5,
          }}
          color="black"
        >
          Destino Final Agua Industrial:{" "}
          {infraestructura.aguaIndustrial
            ? "SI " + (infraestructura.aguaIndustrial || 0) + " M3/Año"
            : "NO"}
        </SoftTypography>
      </Grid>
      <Grid item xs={12}>
        <SoftTypography
          variant="body2"
          sx={{
            lineHeight: 0.5,
          }}
          color="black"
        >
          Destino Final Agua NO Industrial:{" "}
          {infraestructura.aguaNoIndustrial
            ? "SI " + (infraestructura.aguaNoIndustrial || 0) + " M3/Año"
            : "NO"}
        </SoftTypography>
      </Grid>
      <Grid item xs={12}>
        <SoftTypography
          variant="body2"
          sx={{
            lineHeight: 0.5,
          }}
          color="black"
        >
          Descripción de Proceso Productivo: {infraestructura.descripcionProcesoIndustrial || ""}
        </SoftTypography>
      </Grid>
      <Firma marginTop={10} />
    </Grid>
  );
};

Infraestructura.propTypes = {
  infraestructura: PropTypes.object.isRequired,
  finalizada: PropTypes.bool,
};

export default Infraestructura;
